"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[41],{

/***/ 30041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgKingBed = function SvgKingBed(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M13.667 6a1 1 0 0 0-.666-.939V4a1 1 0 0 0-.667-.939V1.333a1 1 0 0 0-1-1H2.667a1 1 0 0 0-1 1v1.728A1 1 0 0 0 1.001 4v1.061A1 1 0 0 0 .334 6v1.333c0 .149.035.296.1.429a.333.333 0 0 0-.1.238v1.333a.333.333 0 0 0 .333.334h1v1.183a.333.333 0 1 0 .667 0V9.667h9.333v1.183a.333.333 0 1 0 .667 0V9.667h1a.333.333 0 0 0 .333-.334V8a.333.333 0 0 0-.1-.238c.065-.133.1-.28.1-.429V6Zm-1.666-2.333a.333.333 0 0 1 .333.333v1H7.667V4a.333.333 0 0 1 .334-.333h4ZM2.667 1h8.667a.333.333 0 0 1 .333.333V3H8.001a1 1 0 0 0-1 1 1 1 0 0 0-1-1H2.334V1.333A.333.333 0 0 1 2.667 1Zm-1 3a.333.333 0 0 1 .334-.333h4A.333.333 0 0 1 6.334 4v1H1.667V4Zm-.666 2a.333.333 0 0 1 .333-.333h11.333a.333.333 0 0 1 .334.333v1.333a.333.333 0 0 1-.334.334H1.334a.333.333 0 0 1-.333-.334V6Zm12 3H1v-.667h12V9Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgKingBed);

/***/ })

}]);